<script>
    import Login from "./Login.svelte";
    import { Toaster } from 'svelte-sonner';
</script>

<main>
    <Toaster position="top-right" richColors closeButton expand={false} duration={4000} />
    <Login />
</main>